import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Email } from "../../models/email";
import { FirebaseService } from "../../providers/firebase.service";
import { FirebaseListObservable } from "angularfire2/database-deprecated";
import * as _ from 'lodash';

@Component({
  selector: 'scs-site-admin-emails',
  templateUrl: './site-admin-emails.component.html',
  styleUrls: ['./site-admin-emails.component.css']
})
export class SiteAdminEmailsComponent implements OnChanges {
  @Input() clientData;
  @Input() emailDBName;
  @Input() emailName;
  @Input() locationKey;

  emailList: FirebaseListObservable<any>;
  email: Email;
  selectedEmail: Email;
  displayEmailDialog: boolean;
  newEmail: boolean;

  constructor(public afService: FirebaseService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['locationKey']) {
      this.emailList = this.afService.getClientEmailList(this.clientData.$key, this.emailDBName, this.locationKey);
    }
  }

  showEmailDialogToAdd() {
    this.newEmail = true;
    this.email = new Email();
    this.displayEmailDialog = true;
  }

  onEmailRowSelect(event) {
    this.newEmail = false;
    this.email = event.data;
    this.displayEmailDialog = true;
  }

  saveEmail() {
    this.email.email = this.email.email.replace(/\s/g, '');
    if (this.newEmail == true) {
      this.afService.saveEmailToList(this.clientData, this.emailDBName, this.email, this.locationKey).then(() => {
        this.afService.openSnackBar('Email successfully added.');
      });
    }
    else {
      this.afService.updateEmailList(this.clientData, this.emailDBName, this.email, this.locationKey).then(() => {
        this.afService.openSnackBar('Email successfully saved.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }

    this.email = null;
    this.displayEmailDialog = false;
  }

  deleteEmail() {
    console.log(this.selectedEmail)
    this.afService.deleteEmailFromList(this.clientData, this.emailDBName, this.selectedEmail, this.locationKey).then(() => {
      this.afService.openSnackBar('Email successfully Deleted.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
    this.selectedEmail = null;
    this.displayEmailDialog = false;
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/site-admin-emails/site-admin-emails.component.ts